/*
	s_detectpage.js
*/

var instrument;

const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
const isMobile = window.innerWidth <= 1250 && window.matchMedia("(orientation: portrait)").matches;

// window.currentPage
// 0 -> HOME
// 1 -> ABOUT
// 2 -> INSTRUMENTS
// 3 -> PIANO
window.PAGE_HOME = 0;
window.PAGE_ABOUT = 1;
window.PAGE_INSTRUMENTS = 2;
window.PAGE_PIANO = 3;
window.PAGE_CART = 4;
window.PAGE_TEAM = 5;
window.PAGE_PRIVACY = 6;
window.PAGE_MALLETS = 7;
window.PAGE_TXT = 8;
window.PAGE_GENERIC = 100;

window.PAGE_TYPE_INSTRUMENTS = 1;


$(document).on({
    mouseenter: function () {
        $('.cursor').toggleClass('animate');
    },
    mouseleave: function () {
        $('.cursor').toggleClass('animate');
    }
}, ".menu-link"); 

$(document).on({
    mouseenter: function () {
        $('.cursor').toggleClass('animate');
    },
    mouseleave: function () {
        $('.cursor').toggleClass('animate');
    }
}, ".text-link"); 

$(document).on({
    mouseenter: function () {
        $('.cursor').toggleClass('animate');
    },
    mouseleave: function () {
        $('.cursor').toggleClass('animate');
    }
}, ".svg-wrapper"); 

function detectCurrentPage() {
    window.currentPage = 0;
    window.currentPageType = 0;
    this._background = this._backgroundMain;
    if(document.URL.toLowerCase().indexOf('piano') != -1) {
      window.currentPage = window.PAGE_PIANO;
      window.currentPageType = window.PAGE_TYPE_INSTRUMENTS;
      this._background = this._backgroundInstruments;
    } else if(document.URL.toLowerCase().indexOf('mallets') != -1) {
      window.currentPage = window.PAGE_MALLETS;
      window.currentPageType = window.PAGE_TYPE_INSTRUMENTS;
    } else if(document.URL.toLowerCase().indexOf('textures') != -1) {
      window.currentPage = window.PAGE_TXT;
      window.currentPageType = window.PAGE_TYPE_INSTRUMENTS;
    } else if(document.URL.toLowerCase().indexOf('instruments') != -1) {
      window.currentPage = window.PAGE_INSTRUMENTS;
    } else if(document.URL.toLowerCase().indexOf('about') != -1 || document.URL.toLowerCase().indexOf('black-friday') != -1) {
      window.currentPage = window.PAGE_ABOUT;
    } else if(document.URL.toLowerCase().indexOf('cart') != -1) {
      window.currentPage = window.PAGE_CART;
    } else if(document.URL.toLowerCase().indexOf('team') != -1) {
      window.currentPage = window.PAGE_TEAM;
    }  else if(document.URL.toLowerCase().indexOf('faq') != -1 || document.URL.toLowerCase().indexOf('eula') != -1 || document.URL.toLowerCase().indexOf('privacy') != -1) {
      window.currentPage = window.PAGE_GENERIC;
    } else {
        window.currentPage = window.PAGE_HOME;
    }

    if(window.currentPage == window.PAGE_PIANO) {
        instrument = 'piano';
    } else if(window.currentPage == window.PAGE_MALLETS) {
        instrument = 'mallets';
    } else if(window.currentPage == window.PAGE_TEXTURES) {
        instrument = 'txt';
    }
}
detectCurrentPage();